/* ==========================================================================
   708 Supply Co. — theme behaviour
   Menu drawer, cart drawer + AJAX cart, product form (variants, gallery,
   add to cart, sticky bar), fitment checker, accordions, toasts.
   No dependencies. Everything hangs off data-c708-* attributes.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.c708 && window.c708.routes) || {};
  var routes = {
    cart: ROOT.cart || '/cart',
    add: ROOT.add || '/cart/add',
    change: ROOT.change || '/cart/change',
    cartJs: (ROOT.cart || '/cart') + '.js'
  };
  var DRAWER_SECTION = (window.c708 && window.c708.drawerSection) || '708-cart-drawer';
  var money = (window.c708 && window.c708.moneyFormat) || '${{amount}}';

  /* ---------- helpers */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var s = parts.join('.');
    if (money.indexOf('{{amount_no_decimals}}') > -1) return money.replace('{{amount_no_decimals}}', parts[0]);
    return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function lockScroll(lock) { document.documentElement.style.overflow = lock ? 'hidden' : ''; }
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 's708-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  function setBusy(btn, busy) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!busy);
    btn.disabled = !!busy;
  }

  /* ---------- menu drawer */
  (function menu() {
    var menu = $('[data-c708-menu]');
    if (!menu) return;
    var lastFocus;
    function open() { lastFocus = document.activeElement; menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); lockScroll(true); var f = $('[data-c708-menu-close]', menu); if (f) f.focus(); }
    function close() { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); lockScroll(false); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    $$('[data-c708-menu-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-c708-menu-close]', menu).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  })();

  /* ---------- cart */
  var Cart = {
    drawer: null, busyCount: 0,
    init: function () {
      this.drawer = $('[data-c708-drawer]');
      var self = this;
      $$('[data-c708-cart-open]').forEach(function (a) {
        on(a, 'click', function (e) {
          if (!self.drawer) return; // no drawer on this page -> follow link to /cart
          if (document.body.classList.contains('template-cart')) return;
          e.preventDefault(); self.open();
        });
      });
      if (this.drawer) {
        // delegated: the drawer body is re-rendered after every cart change
        on(this.drawer, 'click', function (e) { if (e.target.closest('[data-c708-drawer-close]')) self.close(); });
        on(document, 'keydown', function (e) { if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) self.close(); });
      }
      // line item controls (drawer + cart page), event delegation
      on(document, 'click', function (e) {
        var rm = e.target.closest('[data-c708-remove]');
        if (rm) { e.preventDefault(); self.change(rm.getAttribute('data-c708-remove'), 0, rm); return; }
        var step = e.target.closest('[data-c708-step]');
        if (step) {
          e.preventDefault();
          var wrap = step.closest('[data-c708-line]');
          var input = $('input[data-c708-qty]', wrap);
          var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-c708-step'), 10));
          input.value = q;
          self.change(wrap.getAttribute('data-c708-line'), q, step);
          return;
        }
        var addon = e.target.closest('[data-c708-addon]');
        if (addon) { e.preventDefault(); self.add({ id: addon.getAttribute('data-c708-addon'), quantity: 1 }, addon); }
      });
      on(document, 'change', function (e) {
        var input = e.target.closest('input[data-c708-qty]');
        if (!input) return;
        var wrap = input.closest('[data-c708-line]');
        self.change(wrap.getAttribute('data-c708-line'), Math.max(0, parseInt(input.value, 10) || 0), input);
      });
    },
    open: function () {
      if (!this.drawer) { window.location.href = routes.cart; return; }
      this.drawer.classList.add('is-open'); this.drawer.setAttribute('aria-hidden', 'false'); lockScroll(true);
      var c = $('[data-c708-drawer-close]', this.drawer); if (c) c.focus();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open'); this.drawer.setAttribute('aria-hidden', 'true'); lockScroll(false);
    },
    sectionsParam: function () {
      var ids = [DRAWER_SECTION];
      var page = $('[data-c708-cart-page]');
      if (page && page.getAttribute('data-section-id')) ids.push(page.getAttribute('data-section-id'));
      return ids.join(',');
    },
    render: function (sections) {
      if (!sections) return;
      var self = this;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === DRAWER_SECTION && self.drawer) {
          var fresh = $('[data-c708-drawer-inner]', doc);
          var cur = $('[data-c708-drawer-inner]', self.drawer);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        } else {
          var page = $('[data-c708-cart-page][data-section-id="' + id + '"]');
          var freshPage = $('[data-c708-cart-page]', doc);
          if (page && freshPage) page.innerHTML = freshPage.innerHTML;
        }
      });
    },
    updateCount: function (count) {
      $$('[data-c708-cart-count]').forEach(function (el) {
        el.textContent = count > 99 ? '99+' : count;
        el.hidden = !count;
      });
    },
    setBusyState: function (busy) {
      if (this.drawer) this.drawer.classList.toggle('is-busy', busy);
      var page = $('[data-c708-cart-page]'); if (page) page.classList.toggle('is-busy', busy);
    },
    add: function (payload, btn, opts) {
      var self = this; opts = opts || {};
      setBusy(btn, true);
      var body;
      if (payload instanceof FormData) { body = payload; body.append('sections', this.sectionsParam()); body.append('sections_url', window.location.pathname); }
      else { body = new FormData(); Object.keys(payload).forEach(function (k) { body.append(k, payload[k]); }); body.append('sections', this.sectionsParam()); body.append('sections_url', window.location.pathname); }
      return fetch(routes.add + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.json.description || res.json.message || 'Could not add to cart'); }
          self.render(res.json.sections);
          return self.refreshCount().then(function () {
            if (!opts.silent) { self.open(); document.dispatchEvent(new CustomEvent('c708:cart:added', { detail: res.json })); }
            self.syncGift();
          });
        })
        .catch(function (err) { if (!opts.silent) toast(err.message || 'Something went wrong. Please try again.'); })
        .then(function () { setBusy(btn, false); });
    },
    change: function (key, qty, el) {
      var self = this;
      this.setBusyState(true);
      var body = { id: key, quantity: qty, sections: this.sectionsParam(), sections_url: window.location.pathname };
      return fetch(routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not update cart');
          self.render(res.json.sections);
          self.updateCount(res.json.item_count);
          if (res.json.items) {
            var line = res.json.items.filter(function (i) { return i.key === key; })[0];
            if (line && qty > line.quantity) toast('Only ' + line.quantity + ' available right now.');
          }
          self.syncGift();
        })
        .catch(function (err) { toast(err.message || 'Could not update cart.'); })
        .then(function () { self.setBusyState(false); });
    },
    /* free gift: Liquid computes the state on every render; here we make the cart match it.
       Adds the gift when a kit is in the cart, removes it again only if we were the ones who added it. */
    giftBusy: false, giftFailed: false,
    syncGift: function () {
      var self = this;
      var g = $('[data-c708-gift]');
      if (!g || this.giftBusy || this.giftFailed) return;
      var unlocked = g.getAttribute('data-gift-state') === 'true';
      var inCart = g.getAttribute('data-gift-in-cart') === 'true';
      var auto = g.getAttribute('data-gift-auto') === 'true';
      var variant = g.getAttribute('data-gift-variant');
      var key = g.getAttribute('data-gift-key');
      if (unlocked && !inCart && variant) {
        this.giftBusy = true;
        this.add({ id: variant, quantity: 1, 'properties[_gift]': 'Free with your kit' }, null, { silent: true })
          .then(function () { self.giftBusy = false; if ($('[data-c708-gift]') && $('[data-c708-gift]').getAttribute('data-gift-in-cart') !== 'true') self.giftFailed = true; });
      } else if (!unlocked && inCart && auto && key) {
        this.giftBusy = true;
        this.change(key, 0).then(function () { self.giftBusy = false; });
      }
    },
    refreshCount: function () {
      var self = this;
      return fetch(routes.cartJs, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { self.updateCount(c.item_count); }).catch(function () {});
    }
  };
  Cart.init();
  Cart.syncGift();
  window.c708Cart = Cart;

  /* ---------- product form */
  $$('[data-c708-product]').forEach(function (root) {
    var data = $('[data-c708-variants]', root);
    var variants = data ? JSON.parse(data.textContent) : [];
    var optionCount = parseInt(root.getAttribute('data-option-count'), 10) || 1;
    var form = $('form[data-c708-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var priceEl = $('[data-c708-price]', root);
    var compareEl = $('[data-c708-compare]', root);
    var saveEl = $('[data-c708-save]', root);
    var atc = $('[data-c708-atc]', root);
    var atcLabel = atc ? $('.b708__label', atc) : null;
    var stickyBar = $('[data-c708-sticky]', root);
    var stickyPrice = stickyBar ? $('[data-c708-sticky-price]', stickyBar) : null;
    var stickyBtn = stickyBar ? $('[data-c708-sticky-atc]', stickyBar) : null;
    var err = $('[data-c708-err]', root);
    var labels = { add: root.getAttribute('data-t-add') || 'Add to cart', soldout: root.getAttribute('data-t-soldout') || 'Sold out', unavailable: root.getAttribute('data-t-unavailable') || 'Unavailable' };

    /* gallery */
    var track = $('[data-c708-track]', root);
    var slides = $$('[data-c708-slide]', root);
    var dots = $$('[data-c708-dot]', root);
    var thumbs = $$('[data-c708-thumb]', root);
    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      markSlide(i);
    }
    function markSlide(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); if (k === i && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
    }
    if (track) {
      var raf;
      on(track, 'scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth); markSlide(Math.max(0, Math.min(slides.length - 1, i)));
        });
      }, { passive: true });
      thumbs.forEach(function (t, k) { on(t, 'click', function () { goTo(k); }); });
    }
    /* The gallery stays where the shopper left it when a color is picked (no photo swapping). */

    /* variant matching */
    function selected() {
      var out = [];
      for (var i = 1; i <= optionCount; i++) {
        var b = $('[data-c708-opt][data-option-index="' + i + '"][aria-checked="true"]', root);
        out.push(b ? b.getAttribute('data-value') : null);
      }
      return out;
    }
    function findVariant(sel) {
      return variants.filter(function (v) {
        for (var i = 0; i < sel.length; i++) { if (v.options[i] !== sel[i]) return false; }
        return true;
      })[0];
    }
    function updateAvailability(sel) {
      // grey out option values that have no available variant given the other selections
      $$('[data-c708-opt]', root).forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10) - 1;
        var test = sel.slice(); test[idx] = btn.getAttribute('data-value');
        var any = variants.some(function (v) {
          for (var i = 0; i < test.length; i++) { if (i !== idx && test[i] && v.options[i] !== test[i]) return false; }
          return v.options[idx] === test[idx] && v.available;
        });
        btn.classList.toggle('is-unavailable', !any);
      });
    }
    function apply(v, sel) {
      $$('[data-c708-opt-current]', root).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-c708-opt-current'), 10) - 1; el.textContent = sel[i] || '';
      });
      updateAvailability(sel);
      if (!v) {
        if (atcLabel) atcLabel.textContent = labels.unavailable; if (atc) atc.disabled = true;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
      if (saveEl) { saveEl.textContent = onSale ? 'Save ' + formatMoney(v.compare_at_price - v.price) : ''; saveEl.hidden = !onSale; }
      if (atc) { atc.disabled = !v.available; if (atcLabel) atcLabel.textContent = v.available ? labels.add : labels.soldout; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? labels.add : labels.soldout; }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-c708-opt]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var idx = btn.getAttribute('data-option-index');
        $$('[data-c708-opt][data-option-index="' + idx + '"]', root).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        var sel = selected(); apply(findVariant(sel), sel);
      });
    });
    if (variants.length) { var sel0 = selected(); apply(findVariant(sel0), sel0); }

    /* quantity */
    $$('[data-c708-qty-step]', root).forEach(function (b) {
      on(b, 'click', function () {
        var input = $('input[name="quantity"]', root); if (!input) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-c708-qty-step'), 10));
      });
    });

    /* add to cart */
    function submit(btn) {
      if (!form) return;
      if (err) err.classList.remove('is-on');
      var fd = new FormData(form);
      Cart.add(fd, btn).then(function () { });
    }
    on(form, 'submit', function (e) { e.preventDefault(); submit(atc); });
    on(stickyBtn, 'click', function () { submit(stickyBtn); });

    /* sticky bar visibility */
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top < 0; // passed it
        stickyBar.classList.toggle('is-on', !e.isIntersecting && below);
      }, { threshold: 0 });
      io.observe(atc);
    }
  });

  /* ---------- fitment checker */
  $$('[data-c708-fit]', document).forEach(function (fit) {
    var state = { vehicle: null, fitsVehicle: null, l: null, w: null, lmc: null, v12: null };
    var single = { l: parseFloat(fit.getAttribute('data-single-l')) || 6, w: parseFloat(fit.getAttribute('data-single-w')) || 4 };
    var dbl = { l: parseFloat(fit.getAttribute('data-double-l')) || 9, w: parseFloat(fit.getAttribute('data-double-w')) || 4 };
    var result = $('[data-c708-fit-result]', fit);
    var verdict = $('[data-c708-fit-verdict]', fit);
    var why = $('[data-c708-fit-why]', fit);
    var ctaSingle = $('[data-c708-fit-cta="single"]', fit);
    var ctaDouble = $('[data-c708-fit-cta="double"]', fit);
    var ctaPhoto = $('[data-c708-fit-cta="photo"]', fit);
    var lIn = $('[data-c708-fit-l]', fit), wIn = $('[data-c708-fit-w]', fit);

    function press(group, btn) {
      $$('[data-c708-fit-chip][data-group="' + group + '"]', fit).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
    }
    $$('[data-c708-fit-chip]', fit).forEach(function (btn) {
      on(btn, 'click', function () {
        var g = btn.getAttribute('data-group'); press(g, btn);
        var val = btn.getAttribute('data-value');
        if (g === 'vehicle') { state.vehicle = btn.textContent.trim(); state.fitsVehicle = val; }
        if (g === 'lmc') state.lmc = val;
        if (g === 'v12') state.v12 = val;
        compute();
      });
    });
    /* make -> model dropdowns */
    var makeSel = $('[data-c708-fit-make]', fit), modelSel = $('[data-c708-fit-model]', fit);
    if (makeSel && modelSel) {
      var modelOpts = $$('option[data-make]', modelSel);
      on(makeSel, 'change', function () {
        var mk = makeSel.value;
        modelSel.value = '';
        modelOpts.forEach(function (o) { o.hidden = o.getAttribute('data-make') !== mk; o.disabled = o.hidden; });
        if (mk === '__other') {
          modelSel.disabled = true; modelSel.closest('.s708-select').classList.add('is-off');
          state.vehicle = makeSel.options[makeSel.selectedIndex].text; state.fitsVehicle = 'photo'; compute();
        } else {
          modelSel.disabled = !mk; modelSel.closest('.s708-select').classList.toggle('is-off', !mk);
          state.vehicle = null; state.fitsVehicle = null;
          if (result) result.hidden = true;
          if (mk && modelSel.focus) modelSel.focus();
        }
      });
      on(modelSel, 'change', function () {
        if (!modelSel.value) { state.fitsVehicle = null; return; }
        state.vehicle = makeSel.value + ' ' + modelSel.options[modelSel.selectedIndex].text;
        state.fitsVehicle = modelSel.value;
        compute();
      });
    }
    [lIn, wIn].forEach(function (inp) { on(inp, 'input', function () { state.l = parseFloat(lIn.value) || null; state.w = parseFloat(wIn.value) || null; compute(); }); });

    function show(kind, title, text) {
      result.hidden = false;
      verdict.textContent = title; verdict.className = 's708-fit__verdict is-' + kind; // good = green, no = red, warn = neutral
      why.textContent = text;
      if (ctaSingle) ctaSingle.hidden = !(kind === 'good' && (state.rec === 'single' || state.rec === 'both'));
      if (ctaDouble) ctaDouble.hidden = !(kind === 'good' && (state.rec === 'double' || state.rec === 'both'));
      if (ctaPhoto) ctaPhoto.hidden = (kind === 'good' || kind === 'no');
      if (result.scrollIntoView && window.innerWidth < 750) result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function compute() {
      var answered = state.fitsVehicle || (state.l && state.w);
      if (!answered && state.lmc === null && state.v12 === null) return;
      if (state.lmc === 'yes') { state.rec = null; return show('no', 'Not a fit', fit.getAttribute('data-text-lmc') || 'These kits do not fit LMC headliners.'); }
      if (state.v12 === 'no') { state.rec = null; return show('no', 'Not a fit', fit.getAttribute('data-text-12v') || 'Kits must be connected to 12V power only.'); }
      if (!answered) return;
      var rec = null, text = '';
      if (state.l && state.w) {
        var L = Math.max(state.l, state.w), W = Math.min(state.l, state.w);
        var sFits = L <= single.l && W <= single.w;
        var dFits = L <= dbl.l && W <= dbl.w;
        if (sFits && dFits) { rec = 'both'; text = 'Your opening (' + L + ' x ' + W + ' in) is covered by both plates. Pick Single for one lens or Double for two.'; }
        else if (dFits) { rec = 'double'; text = 'Your opening (' + L + ' x ' + W + ' in) is wider than the Single plate but the Double plate (' + dbl.l + ' x ' + dbl.w + ' in) covers it.'; }
        else { rec = 'photo'; text = 'Your opening is larger than our ' + dbl.l + ' x ' + dbl.w + ' in Double plate. Send us a photo and the measurement and we will tell you straight.'; }
      } else if (state.fitsVehicle) {
        rec = state.fitsVehicle;
        var names = { single: 'Single kit', double: 'Double kit', both: 'Single or Double', photo: 'Send a photo' };
        text = fit.getAttribute('data-text-' + rec) || '';
        if (rec === 'photo') text = text || 'We have not confirmed this one yet. Send a photo of your dome light with a tape measure across it and we will tell you which kit fits.';
      }
      state.rec = rec;
      if (rec === 'photo') return show('warn', 'Let us check', text);
      var titles = { single: 'Single kit fits', double: 'Double kit fits', both: 'Both kits fit' };
      var extra = (state.lmc === null || state.v12 === null) ? ' Confirm the two questions below to be sure.' : '';
      show('good', titles[rec] || 'Fits', text + extra);
    }
  });

  var measureHeader = function () {};
  /* ---------- sale countdown (top bar). daily = to the next midnight in the store's timezone, date = fixed end */
  $$('[data-c708-countdown]').forEach(function (bar) {
    var mode = bar.getAttribute('data-mode') || 'daily';
    var tz = bar.getAttribute('data-tz') || 'America/Chicago';
    var endRaw = bar.getAttribute('data-end') || '';
    var els = { d: $('[data-c708-cd="d"]', bar), h: $('[data-c708-cd="h"]', bar), m: $('[data-c708-cd="m"]', bar), s: $('[data-c708-cd="s"]', bar) };
    var dayUnit = $('.s708-timer__unit--d', bar);
    function nowInTz() { return new Date(new Date().toLocaleString('en-US', { timeZone: tz })); }
    function target() {
      if (mode === 'date') {
        var m = endRaw.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
        if (!m) return null;
        return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59); // in tz-local terms
      }
      var t = nowInTz(); t.setHours(24, 0, 0, 0); return t;
    }
    var end = target();
    if (!end) { bar.hidden = true; return; }
    function tick() {
      var diff = end - nowInTz();
      if (diff <= 0) {
        if (mode === 'daily') { end = target(); diff = end - nowInTz(); }
        else { bar.hidden = true; measureHeader(); return; }
      }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), mi = Math.floor(diff % 36e5 / 6e4), se = Math.floor(diff % 6e4 / 1e3);
      if (dayUnit) dayUnit.hidden = d < 1;
      if (els.d) els.d.textContent = d;
      if (els.h) els.h.textContent = (h < 10 ? '0' : '') + h;
      if (els.m) els.m.textContent = (mi < 10 ? '0' : '') + mi;
      if (els.s) els.s.textContent = (se < 10 ? '0' : '') + se;
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- sticky header: the announcement scrolls away, the bar stays */
  (function stickyHeader() {
    var wrap = $('.s708-header-section');
    if (!wrap) return;
    var ann = $('.s708-announce', wrap);
    function measure() { wrap.style.setProperty('--c708-announce-h', (ann && !ann.hidden ? ann.offsetHeight : 0) + 'px'); }
    measureHeader = measure;
    measure();
    on(window, 'resize', measure);
    on(window, 'load', measure);
    if (ann && 'ResizeObserver' in window) new ResizeObserver(measure).observe(ann);
  })();

  /* ---------- misc */
  // open drawer automatically when redirected with ?cart=open
  if (/[?&]cart=open/.test(window.location.search)) Cart.open();
  // Shopify theme editor: re-init when a section reloads
  document.addEventListener('shopify:section:load', function () { /* sections are self-initialising on page load; a full reload keeps things simple */ });
})();
